import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { UTILS__clipboard } from '@/utils/UTILS__clipboard';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { use_effect } from '../_base/use_effect';
import { use_slice_ui } from '../store/use_slices';
import { useToast } from '../use-toast';

export function HOOK_IMAGE__paste_from_clipboard() {
  const { toast } = useToast();
  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { global__is_app_on_focus } = use_slice_ui(['global__is_app_on_focus']);
  /*
   *
   */
  const [image_data_from_clipboard, set_image_data_from_clipboard] = useState(DTO__file_data.CREATE_STUB());

  /*
   *
   */
  use_effect(() => {
    void check_clipboard();
  }, [global__is_app_on_focus]);

  async function check_clipboard() {
    let image_data = await UTILS__clipboard.get_image_file_data_from_clipboard(toast, t_base_ui);

    set_image_data_from_clipboard(image_data);
  }

  return { image_data_from_clipboard };
}
